import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';

import { environment } from '../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { AuthService } from '../auth/login';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { LoaderService } from '../components/loader/service/loader.service';

@Injectable()
export class HttpClientService implements HttpInterceptor {
  //   private authService: AuthService;
  constructor(private injector: Injector, private loader: LoaderService, private snackbar: MatSnackBar) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqClone: any;
    let url;
    let headers;
    let token = 'Bearer ' + sessionStorage.getItem('token');

    // if (!this.authService) {
    //   this.authService = this.injector.get(AuthService);
    // }
    // const oauthData = this.authService.oauthData.value;
    if (req.url.indexOf('@cec-api') != -1) {
      if (req.url.indexOf('search') == -1) {
        this.loader.showLoader();
      }

      url = req.url.replace('@cec-api/', environment.endPointApi);
    }
    if (req.url.indexOf('register') == -1) {
      headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: token,
      };
    }
    /*
    if (req.url.indexOf('/user/avatar/') != -1) {
      console.log(true);
      headers = {
        'Content-Type': undefined,
        'Access-Control-Allow-Origin': '*',
        Authorization: token,
      };
    } */

    if (req.headers.has('encrypt')) {
      delete headers['Content-Type'];
    }

    reqClone = req.clone({
      url: url,
      setHeaders: headers,
    });
    return next.handle(reqClone).pipe(catchError(this.catchAuthError(this)));
  }

  private catchAuthError(self: HttpClientService) {
    // we have to pass HttpService's own instance here as `self`
    this.loader.closeLoader();

    return (res: Response) => {
      if (res.status === 401) {
        // valid currenty token

        this.snackbar.open('Erro na autenticação, faça login novamente', null, {
          duration: 2000,
        });
        sessionStorage.clear();
        window.location.replace('/');
      }
      return observableThrowError(res);
    };
  }

  verifyIsSearchRoute() {}
}
